import React from "react";
import { ProviderContext, withSnackbar } from "notistack";
import { FormattedMessage, injectIntl, WrappedComponentProps } from "react-intl";
import { Button } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import PopupHeader, { PositionTitle } from "../../../popup/PopupHeader/PopupHeader";
import PopupAction from "../../../popup/PopupAction/PopupAction";
import Collection from "../../../../domain/Collection";
import container from "../../../../container";

interface StateInterface {
    loading: boolean;
}

interface PropsInterface extends WrappedComponentProps, ProviderContext {
    close: (isUpdate?: boolean) => void;
    collection: Collection;
}

class UnshareCollection extends React.Component<PropsInterface, StateInterface> {
    readonly state = {
        loading: false,
    };

    constructor(props: PropsInterface) {
        super(props);
        this.closePopup = this.closePopup.bind(this);
    }

    unshareCollection = async () => {
        if (this.state.loading) {
            return;
        }
        this.setState({ loading: true });

        try {
            await container.collectionActionApiService.shareCollection(this.props.collection.getId(), [], []);
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "app.collection.unlock.success" }), { variant: "success" });
            this.props.close(true);
        } catch (e) {
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "app.error.undefined" }), { variant: "error" });
            this.setState({ loading: false });
        }
    };

    private closePopup() {
        this.props.close();
    }

    render() {
        return (
            <div className="share-collection">
                <PopupHeader positionHeader={PositionTitle.CENTER}>
                    <FormattedMessage id="app.collection.unshare.title" />
                </PopupHeader>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <br />
                        <FormattedMessage id={"app.collection.unshare.description"} values={{ collectionName: this.props.collection.getName() }} />
                    </DialogContentText>
                </DialogContent>
                <PopupAction>
                    <Button type="submit" onClick={this.unshareCollection} className="button--more-padding" disabled={this.state.loading}>
                        <FormattedMessage id="app.collection.unshare" />
                    </Button>
                    <Button type="submit" onClick={this.closePopup} className="button--more-padding">
                        <FormattedMessage id="app.standard.popup.button.cancel" />
                    </Button>
                </PopupAction>
            </div>
        );
    }
}

export default withSnackbar(injectIntl(UnshareCollection));
